import { endpoints } from 'Constants';

const WalletPaymentServices = {
	barcodeCheck: (params) => ({
		baseURL: endpoints.WALLET_PAYMENT.BARCODE_CHECK(params?.id),
		method: 'POST',
		data: { barcode: params?.barcode },
	}),
	newTransaction: (params) => ({
		baseURL: endpoints.WALLET_PAYMENT.NEW_TRANSACTION(),
		method: 'POST',
		data: { amount: params?.amount, business_id: params?.business_id },
	}),
	TransactionReport: (params) => ({
		baseURL: endpoints.WALLET_PAYMENT.TRANSACTION_REPORTS(),
		method: 'GET',
		params,
	}),
};

export default WalletPaymentServices;
